export const PrivacyLevel = {
    PRIVATE: "PrivacyLevel.PRIVATE",
    PUBLIC: "PrivacyLevel.PUBLIC"
};
